<template>
  <div>
    <b-card class="standardpage reports">
      <b-card-header>
        <b-row>
          <b-col cols="12" md="4" class="text-sm-left pt-1">
            <i :class="nltransactions.icon" class="mr-1"></i>
            <span>{{ nltransactions.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <!-- <b-row no-gutters v-if="showfilter">
                <b-col>
                  <b-button
                    @click="showfilter = !showfilter"
                    variant="link"
                    class="card-header-action"
                    squared
                    size="sm"
                  >
                    <i class="fa fa-filter pr-2"></i>Filter...</b-button
                  >
                </b-col>
               
              </b-row> -->
            <b-row v-if="!showfilter">

              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Transaction Date" label-size="sm">

                  <b-input-group>
                    <daterangepicker size="sm" ref="datetransaction" v-model="datetransaction" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="false"
                      :single-date-picker="false">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="
                        datetransaction = {
                          startDate: null,
                          endDate: null,
                        }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Transaction Type" label-for="transtype" label-cols="12">
                  <b-input-group>
                    <treeselect instanceId="transtype" type="number" v-model="transtype" :multiple="true"
                      :clearable="true" :options="transaction_options" :flatten-search-results="true"
                      :disable-branch-nodes="true" :matchKeys="['id']"></treeselect>
                  </b-input-group>
                </b-form-group>
              </b-col>


              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <span style="padding-top: 0.3em" class="text-primary" id="slaclike-tooltip">Like</span>
                    <b-form-checkbox id="slaclike" v-model="slaclike_visible" class="z-0">
                    </b-form-checkbox>
                  </b-input-group>
                  <b-input-group v-if="!slaclike_visible">
                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                      :clearable="true" :async="true" :load-options="treeselect_loadSLAC" :show-count="true"
                      :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                      :disabled="user.rolename == 'api' || user.rolename == 'client'
                        ">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
                <!-- <b-form-group
                  label-cols="12"
                  label="SL A/C (LIKE %)"
                  label-size="sm"
                > -->
                <b-input-group v-if="slaclike_visible">
                  <b-form-input v-model="slaclike" :debounce="nltransactions.debounce"
                    placeholder="Client SL A/C (LIKE %)" trim></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" :disabled="!slaclike" @click="slaclike = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <!-- </b-form-group> -->
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                  <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..." v-model="blac"
                    :clearable="true" :async="true" :load-options="treeselect_loadBLAC" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                    :disabled="user.rolename == 'api' || user.rolename == 'client'
                      ">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Ref" label-size="sm" class="mb-0">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <span style="padding-top: 0.3em" class="text-primary" id="reflike-tooltip">Like</span>
                    <b-form-checkbox id="reflike" v-model="reflike_visible" class="z-0">
                    </b-form-checkbox>
                  </b-input-group>
                  <b-input-group v-if="!reflike_visible">
                    <b-form-tags input-id="reflist" v-model="reflist" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Ref List (IA519826,IA519827,...)" size="sm" class="h-29" add-button-text="+"
                      add-on-change remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="reflist = []">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>

                <b-input-group v-if="reflike_visible">
                  <b-form-input v-model="ref" :debounce="nltransactions.debounce" placeholder="Ref Like (IA,IC,CM)"
                    trim></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" :disabled="!ref" @click="ref = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>

              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Transaction Ref ( Paste List )" label-for="reflist" label-cols="12">
                  <b-input-group class="z-0">
                    <b-form-tags input-id="reflist" v-model="reflist" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Ref (IA519826,IA519827,...)" size="sm" class="h-29" add-button-text="+"
                      add-on-change remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="reflist = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Transaction Ref (LIKE %)" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="ref" :debounce="nltransactions.debounce" placeholder="Ref (IA,IC,CM)"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!ref" @click="ref = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->


              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="N/L Accounts" label-size="sm">
                  <treeselect instanceId="nlcode" type="number" v-model="nlcode" :clearable="true"
                    :options="nlcode_options" :multiple="true"></treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." v-model="eventcode" :clearable="true" :async="true"
                    :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Transaction Date" label-size="sm">
                  <b-input-group>
                    <daterangepicker size="sm" ref="datetransaction" v-model="datetransaction" :opens="'right'"
                      :locale-data="locale_data" :ranges="finance_ranges" :linkedCalendars="true"
                      :single-date-picker="'range'">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="
                        datetransaction = {
                          startDate: null,
                          endDate: null,
                        }
                      ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->


              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Entry" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="entry" :debounce="nltransactions.debounce" placeholder="Entry"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!entry" @click="entry = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Ledger" label-for="type" label-cols="12">
                  <b-input-group>
                    <treeselect instanceId="type" type="number" v-model="ledger" :clearable="true"
                      :options="type_options"></treeselect>
                  </b-input-group>
                </b-form-group>
              </b-col>



              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label-cols="12" label="Age" label-size="sm">
                    <b-input-group>
                      <b-form-input
                        v-model="age"
                        :debounce="nltransactions.debounce"
                        placeholder="Age"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="!age"
                          @click="age = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col> -->

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label-cols="12" label="Booking" label-size="sm">
                    <b-input-group>
                      <b-form-input
                        v-model="booking"
                        :debounce="nltransactions.debounce"
                        placeholder="Booking"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="!booking"
                          @click="booking = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col> -->
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="nltransactions" :selectall="nltransactions.selectall"
            :icon="nltransactions.icon" :busy="nltransactions.busy" :toolbarlibrary="nltransactions.toolbarlibrary"
            :tools="nltransactions.tools" :badges="nltransactions.badges" :fields="nltransactions.fields"
            :items="nltransactions.items" :offset="nltransactions.offset" :limit="nltransactions.limit" :downloaded="nltransactions.downloaded"
            :page="nltransactions.page" @load="nltransactions_load" @click="nltransactions_click"
            @select="nltransactions_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="nltransactions.selected" :config="cconfig"
          @discard="nltransactions_click('discard')"></component>
      </div>

      <b-row class="px-3">
        <b-col>
          <b-alert :show="!component && !nltransactions.busy && nltransactions.items.length == 0" variant="success">
            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              <b-col>
                Click
                <b-link id="report-go" class="mt-1 mx-2 nodecoration" title="Go" @click="nltransactions_click('go')"">
                  <i class=" fa fa-play pr-1" aria-hidden="true"></i>Go
                </b-link>when all filter changes are complete.</b-col></b-row>
          </b-alert></b-col>
      </b-row>

    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import NLTransactionEdit from "./Components/NLTransactionEdit";
import NLTransactionEntry from "./Components/NLTransactionEntry";
import NLPost from "./Components/NLPost";
import NLItemEdit from "./Components/NLItemEdit";

export default {
  name: "NLTransactions",
  components: {
    NLTransactionEdit,
    NLTransactionEntry,
    NLPost,
    NLItemEdit
  },
  async mounted() {
    this.accessdenied();
    // this.nltransactions_load();
    // // ONLY ADD ACTIONS IF THE ARRAY EXISTS AND NOT ALREADY ADDED AT CONTROLLED WIDTH
    if (this.nltransactions.actions) {
      if (this.nltransactions.fields.some((e) => e.key === "actions")) {
      } else {
        this.nltransactions.fields.push({
          key: "actions",
          label: "",
          class: "actions w-140px",
        });
      }
    }

    this.agent = this.user.initials;

    this.loadDDL();
  },
  data() {
    return {
      busy: false,
      id: null,
      addEntry: false,
      amount: 0,
      query: null,
      datetransaction: {
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      ref: null,
      credit: null,
      slac: null,
      slaclike: null,
      slaclike_visible: null,
      reflike: null,
      reflike_visible: null,
      blac: null,
      ledger: null,
      transtype: [],
      nlcode: [],
      nlcode_options: [],
      age: null,
      entry: null,
      eventcode: null,
      type: null,
      type_options: [
        { id: "BL", label: "Bought Ledger | BL" },
        { id: "NL", label: "Nominal Ledger | NL" },
        { id: "SL", label: "Sales Ledger | SL" },
      ],
      transaction_options: [
        { id: "BLP", label: "Bought Ledger Payment | BLP" },
        { id: "SLP", label: "Sales Ledger Payment | SLP" },
        { id: "GLJ", label: "Nominal Ledger | GLJ" },
        { id: "INV", label: "Invoice | INV" },
        { id: "CRD", label: "Credit | CRD" },
      ],
      reflist: [],
      gridto: "",
      summary: {
        credits: 0,
        debits: 0,
      },

      slquery_options: [
        {
          id: "*",
          label: "All",
        },
        {
          id: "outstanding",
          label: "Outstanding Balances",
        },
      ],

      nltransactions: {
        title: "Nominal Ledger",
        icon: "fa fa-balance-scale text-primary",
        selectall: false,
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,download,clipboard,edit,deleteconfirm,nlpost",
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-balance-scale",
            position: "toolbar",
            action: "nlpost",
            label: "NL Post",
            component: {
              name: "",
            },
          },
        ],

        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px",
          },
          {
            key: "dateref",
            label: "Date",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment.unix(value / 1000).format("DD/MM/YYYY HH:mm");
              }
              return result;
            },
          },
          {
            key: "ref",
            label: "Ref",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },

          {
            key: "nlcode",
            label: "NL A/C",
            sortable: true,
          },

          {
            key: "blac",
            label: "BL A/C",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "amount",
            label: "Amount",
            sortable: true,
            class: "text-right",
            // formatter: (value, key, item) => {
            //   if (value) {
            //     return parseFloat(value).toFixed(2);
            //   } else {
            //     return value;
            //   }
            // },
            totalled: true,
            total: 0,
          },
          {
            key: "ledger",
            label: "Type",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "transtype",
            label: "Trans",
            sortable: true,
          },

          {
            key: "period",
            label: "Period",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "age",
            label: "Age",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "lineno",
            label: "Line",
            sortable: true,
          },
          {
            key: "entry",
            label: "Entry",
            sortable: true,
          },
          {
            key: "credit",
            label: "Type",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
            // formatter: (value, key, item) => {
            //   let result = "";
            //   if (value) {
            //     result = value.split(" ")[0];
            //   }
            //   return result;
            // },
            // formatter: (value, key, item) => {
            //   let result = "";
            //   if (value) {
            //     result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
            //   }
            //   return result;
            // },
          },
          {
            key: "actions",
            label: "Actions",
            class: "text-center actions w-sm-100pct",
          },
        ],
        badges: [
          {
            key: "credit",
            type: "badge",
            Credit: "primary",
            Debit: "danger",
            formatter: (value, key, item) => {
              if (value == true) {
                return "Debit";
              } else {
                return "Credit";
              }
            },
          },
        ],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  watch: {
    async ref() {
      if (this.ref) {
        this.datetransaction = { startDate: null, endDate: null }

        this.credit = null;
        this.transtype = [];
      } else {
        this.datetransaction = { startDate: this.$moment().format("YYYY-MM-DD"), endDate: this.$moment().add(-1, 'd').format("YYYY-MM-DD") }
      }
      await this.nltransactions_clear();
    },
    async reflist() {
      if (this.reflist.length > 0 ) {
        this.datetransaction = { startDate: null, endDate: null }

        this.credit = null;
        this.transtype = [];
      } else {
        this.datetransaction = { startDate: this.$moment().format("YYYY-MM-DD"), endDate: this.$moment().add(-1, 'd').format("YYYY-MM-DD") }
      }
      await this.nltransactions_clear();
    },
    async reflike_visible() {
      if (this.reflike_visible) {
        this.reflist = []
      } else {
        this.ref = null
      }
      await this.nltransactions_clear();
    },
    async reflike() {
      await this.nltransactions_clear();
    },
    async datetransaction() {
      await this.nltransactions_clear();
    },
    async credit() {
      await this.nltransactions_clear();
    },
    async slac() {
      await this.nltransactions_clear();
    },
    async slaclike_visible() {
      if (this.slaclike_visible) {
        this.slac = []
      } else {
        this.slaclike = null
      }
      await this.nltransactions_clear();
    },
    async slaclike() {
      await this.nltransactions_clear();
    },
    async blac() {
      await this.nltransactions_clear();
    },
    async eventcode() {
      await this.nltransactions_clear();
    },
    async ledger() {
      await this.nltransactions_clear();
    },
    async nlcode() {
      await this.nltransactions_clear();
    },
    async entry() {
      await this.nltransactions_clear();
    },
    async transtype() {
      await this.nltransactions_clear();
    },
  },
  methods: {
    accessdenied() {
      this.nltransactions.denied = [];
      if (!this.user.permissions.includes("nltransactions.delete")) {
        this.nltransactions.denied.push("delete");
      }
      if (!this.user.permissions.includes("nltransactions.save")) {
        this.nltransactions.denied.push("save");
      }
    },
    async loadDDL() {
      //this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
            query nlcodes {
              nlcodes {
                id
                label
              }
            }
          `,
        });
        this.nlcode_options = response.data.nlcodes;
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async nltransactions_clear() {
      let state = this.nltransactions;
      state.items = []
      state.offset = 0
      state.page = 1
    },
    async nltransactions_load(offset, limit, page) {
      console.log("load", offset, limit);

      let state = this.nltransactions;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      if (limit != 0) { state.busy = true; }

      let variables = {
        offset: state.offset,
        limit: state.limit,
        daterefs: [
          this.datetransaction.startDate
            ? this.$moment(this.datetransaction.startDate).format("YYYY-MM-DD")
            : null,
          this.datetransaction.endDate
            ? this.$moment(this.datetransaction.endDate).format("YYYY-MM-DD")
            : null,
        ],
        ref: this.ref,
        reflist: this.reflist.length > 0 ? this.reflist.join(",") : null,
        slaclike: this.slaclike,
        slac: this.slac,
        blac: this.blac,
        eventcode: this.eventcode,
        entry: this.entry,
        ledger: this.ledger,
        transtype: this.transtype.length > 0 ? this.transtype.join(",") : null,

        nlcode: this.nlcode.length > 0 ? this.nlcode.join(",") : null,
        dateformat: "DD/MM/YYYY HH:MM",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query NLTransactions(
              $offset: Int
              $limit: Int            
              $daterefs: [String]
              $ref: String
              $reflist: String
              $slac: String
              $slaclike: String
              $blac: String
              $eventcode: String
              $entry: String
              $ledger: String
              $transtype: String
              $nlcode: String
              $dateformat: String
            ) {
              NLTransactions(
                offset: $offset
                limit: $limit
                                daterefs: $daterefs
                ref: $ref
                reflist: $reflist
                slac: $slac
                slaclike: $slaclike
                blac: $blac
                transtype: $transtype
                eventcode: $eventcode
                entry: $entry
                ledger: $ledger
                nlcode: $nlcode
                dateformat: $dateformat
              ) {
                id
                entry
                lineno
                ref
                nlcode
                dateref
                blac
                slac
                eventcode
                amount
                ledger
                credit
                age
                period
                transtype
                updated_at
                updated_by
                rows
              }
            }
          `,
          variables,
        });

        // USE LOCAL VARIABLE      
        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.NLTransactions
        } else {
          state.items = response.data.NLTransactions;
        }       

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async nltransactions_click(a, ss) {

      let state = this.nltransactions;

      switch (a) {
        case "selectall":
          await this.nltransactions_load(0, 0);
          break;
          case "download_view":
          state.downloaded = []
          state.downloaded = this.state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.nltransactions_load(0, 0);
          break;

        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          break;
        case "go":
          this.component = null;
          this.nltransactions_load();
          break;
        case "add":
        case "edit":
          this.component = "NLItemEdit";
          break;

        case "nlpost":
          this.component = "NLPost";
          break;
        case "delete":
          this.deleteit(ss);
          break;
      }
    },

    async nltransactions_select(ss, tools) {

      let state = this.nltransactions;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "download", "nlpost", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        // enabled = ["edit"];
        // enabled.forEach(function (action, index) {
        //   tool = tools.find((o) => o.action == action);
        //   if (tool) {
        //     tool.disabled = ss.length == 1 ? false : true;
        //   }
        // });
        // > 1
        enabled = ["edit", "deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },
    async deleteit(s) {
      console.log("deleteit", s);

      let rows = [];
      s.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation NLTransactions_delete($rows: [NLTransaction_input]) {
              NLTransactions_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.nltransactions_load(0);
    },
  },
};
</script>

<style></style>